module.exports = "<div class=\"notification-wrapper\" [ngClass]=\"position\">\n    <app-notification-item\n        *ngFor=\"let a of notifications; let i = index\"\n        [item]=\"a\"\n        [timeOut]=\"timeOut\"\n        [clickToClose]=\"clickToClose\"\n        [pauseOnHover]=\"pauseOnHover\"\n        [theClass]=\"theClass\"\n        [animate]=\"animate\"\n        [position]=\"i\"\n        >\n    </app-notification-item>\n</div>"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/common/notification/notification.component.html
// module id = ./src/app/components/common/notification/notification.component.html
// module chunks = main